import Vue from 'vue'
import Router from 'vue-router'

//General
import Login from '@/views/general/Login.vue'

//Apps
import Apps from '@/views/apps/Index.vue'
import AppsAdd from '@/views/apps/add/Index.vue'
import AppsEdit from '@/views/apps/update/Index.vue'
import AppsDashboard from '@/views/apps/AppDashboard.vue'

//Customer
import Customers from '@/views/customer/Index.vue'
import CustomersAdd from '@/views/customer/add/Index.vue'
import CustomersEdit from '@/views/customer/edit/Index.vue'
import CustomersInvoices from '@/views/customer/invoice/Index.vue'
import CustomersInvoiceAdd from '@/views/customer/invoice/create/Index.vue'

//Products
import Products from '@/views/products/ProductSelection.vue'
import AddProducts from '@/views/products/add/Index.vue'
import EditProduct from '@/views/products/edit/Index.vue'

import Categories from '@/views/products/categories/Index.vue'
import AddCategory from '@/views/products/categories/add/Index.vue'
import EditCategory from '@/views/products/categories/edit/Index.vue'

//Users
import Users from '@/views/users/Index.vue'
import UsersAdd from '@/views/users/add/Index.vue'
import UsersEdit from '@/views/users/edit/Index.vue'

//Fonts
import Fonts from '@/views/fonts/Index.vue'
import FontsAdd from '@/views/fonts/add/Index.vue'
import FontsEdit from '@/views/fonts/edit/Index.vue'

//Options
import Options from '@/views/options/Index.vue'
import OptionsAdd from '@/views/options/add/Index.vue'
import OptionsEdit from '@/views/options/edit/Index.vue'

//OptionPacks
import OptionPackAdd from '@/views/options/packs/add/Index.vue'
import OptionPackEdit from '@/views/options/packs/edit/Index.vue'

//Carrier Invoices
import CarrierInvoices from '@/views/carrierInvoice/Index.vue'
//Cartons
import Cartons from '@/views/cartons/Index.vue'

//ACD Invoice
import ACDInvoice from '@/views/customer/acdInvoice/Index.vue'
import ACDInvoiceAdd from '@/views/customer/acdInvoice/create/Index.vue'

//Customs 
import Customs from '@/views/customs/Index.vue'

Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [{
      path: "/auth/login",
      name: "Login",
      component: Login,
      meta: {
        title: "ACS - Login"
      }
    },
    {
      alias: "/",
      path: "/apps",
      name: "Apps",
      component: Apps,
      meta: {
        title: "ACS - Apps"
      }
    },
    {
      path: "/apps/add",
      name: "Add App",
      component: AppsAdd,
      meta: {
        title: "ACS - App hinzufügen"
      }
    },
    {
      path: "/apps/:id",
      name: "App Dashboard",
      component: AppsDashboard,
      meta: {
        title: "ACS - App Dashboard"
      }
    },
    {
      path: "/apps/:id/edit",
      name: "App Bearbeiten",
      component: AppsEdit,
      meta: {
        title: "ACS - App bearbeiten"
      }
    },
    {
      path: "/apps/:id/customers/",
      name: "Customers",
      component: Customers,
      meta: {
        title: "ACS - App Customers"
      }
    },
    {
      path: "/apps/:id/customers/add",
      name: "CustomersAdd",
      component: CustomersAdd,
      meta: {
        title: "ACS - App Customers"
      }
    },
    {
      path: "/apps/:appId/customers/:id/edit",
      name: "CustomersEdit",
      component: CustomersEdit,
      meta: {
        title: "ACS - App Customers"
      }
    },
    {
      path: "/apps/:appId/customers/:customerId/invoice",
      name: "CustomersInvoices",
      component: CustomersInvoices,
      meta: {
        title: "ACS - App Customer Invoices"
      }
    },
    {
      path: "/apps/:appId/customers/:customerId/invoice/add",
      name: "CustomersInvoicesAdd",
      component: CustomersInvoiceAdd,
      meta: {
        title: "ACS - App Customer Add Invoice"
      }
    },
    {
      path: "/apps/:id/users/",
      name: "Users",
      component: Users,
      meta: {
        title: "ACS - App Users"
      }
    },
    {
      path: "/apps/:id/customs/",
      name: "customs",
      component: Customs,
      meta: {
        title: "ACS - App Customs"
      }
    },
    {
      path: "/apps/:id/users/add",
      name: "AddUser",
      component: UsersAdd,
      meta: {
        title: "ACS - Add App Users"
      }
    },
    {
      path: "/apps/:id/users/:userId/edit",
      name: "EditUser",
      component: UsersEdit,
      meta: {
        title: "ACS - Edit App Users"
      }
    },
    {
      path: "/apps/:id/products/",
      name: "Products",
      component: Products,
      meta: {
        title: "ACS - App Products"
      }
    },
    {
      path: "/apps/:id/products/add",
      name: "Add Product",
      component: AddProducts,
      meta: {
        title: "ACS - Add App Products"
      }
    },
    {
      path: "/apps/:id/products/edit/:productId",
      name: "editProduct",
      component: EditProduct,
      meta: {
        title: "ACS - Edit App Products"
      }
    },
    {
      path: "/apps/:id/products/categories",
      name: "categories",
      component: Categories,
      meta: {
        title: "ACS - App Produkt Kategorien"
      }
    },
    {
      path: "/apps/:id/products/categories/add",
      name: "addCategory",
      component: AddCategory,
      meta: {
        title: "ACS - Add Product Category"
      }
    },
    {
      path: "/apps/:id/products/category/edit/:catId",
      name: "editCategory",
      component: EditCategory,
      meta: {
        title: "ACS - Edit Product Category"
      }
    },
    {
      path: "/fonts",
      name: "Fonts",
      component: Fonts,
      meta: {
        title: "ACS - Mange Fonts"
      }
    },
    {
      path: "/fonts/add",
      name: "FontsAdd",
      component: FontsAdd,
      meta: {
        title: "ACS - Add Font"
      }
    },
    {
      path: "/fonts/:id/edit",
      name: "FontsEdit",
      component: FontsEdit,
      meta: {
        title: "ACS - Edit Fonts"
      }
    },
    {
      path: "/options",
      name: "Options",
      component: Options,
      meta: {
        title: "ACS - Mange Options"
      }
    },
    {
      path: "/options/add",
      name: "OptionsAdd",
      component: OptionsAdd,
      meta: {
        title: "ACS - Add Options"
      }
    },
    {
      path: "/options/:id/edit",
      name: "OptionsEdit",
      component: OptionsEdit,
      meta: {
        title: "ACS - Edit Options"
      }
    },
    {
      path: "/options/packs/add",
      name: "OptionPackAdd",
      component: OptionPackAdd,
      meta: {
        title: "ACS - Add Options Pack"
      }
    },
    {
      path: "/options/packs/:id/edit",
      name: "OptionsPackEdit",
      component: OptionPackEdit,
      meta: {
        title: "ACS - Edit Options Pack"
      }
    },
    {
      path: "/carrierInvoices",
      name: "Carrier Invoices",
      component: CarrierInvoices,
      meta: {
        title: "ACS - Carrier Invoice Upload"
      }
    },
    {
      path: "/cartons",
      name: "Cartons",
      component: Cartons,
      meta: {
        title: "ACS - Cartons"
      }
    },

    {
      path: "/acdInvoice",
      name: "ACD Invoice",
      component: ACDInvoice,
      meta: {
        title: "ACS - ACD Invoice"
      }
    },
    {
      path: "/acdInvoice/add",
      name: "CreateACDInvoice",
      component: ACDInvoiceAdd,
      meta: {
        title: "ACS - ACD Invoice Add"
      }
    },



  ]
})